import * as React from 'react'
import { cn } from '../../lib/utils'
import { ThemaLogoAccentMotief, type PortalThemaSoort } from './thema-motieven'

/**
 * batch-67 portal-thema (FO-504) - het logo-accent: een kleine overlay-SVG
 * (muts, mijter, hoedje, sterretje, ei, kroontje) op het STREEP-logo in de
 * portal-topbar en -zijbalk.
 *
 * Plaatsing: de letters van het logo staan in de onderste 43 procent van het
 * logovlak (y 173-305 van 305) en rechts van de groene streep; de ruimte
 * rechtsboven is leeg. Het accent staat daar, binnen het logovlak, dus het
 * vergroot geen tap-target en dekt geen inkt af. `pointer-events-none` en
 * `aria-hidden`: puur decoratief. De PWA-splash en het manifest raken we niet.
 *
 * Gebruik: wikkel het logo in een `relative inline-flex` en zet het accent
 * ernaast:
 *
 *   <span className="relative inline-flex">
 *     <LogoLight className="h-6 w-auto" />
 *     <LogoAccent soort={soort} />
 *   </span>
 */
export interface LogoAccentProps {
  soort: PortalThemaSoort | null | undefined
  /** Overschrijft positie/grootte (default rechtsboven, 14 px). */
  className?: string
}

export function LogoAccent({ soort, className }: LogoAccentProps) {
  if (!soort) return null
  return (
    <span
      aria-hidden="true"
      data-logo-accent={soort}
      className={cn('pointer-events-none absolute -top-0.5 right-0 h-3.5 w-3.5', className)}
    >
      <ThemaLogoAccentMotief soort={soort} className="h-full w-full" />
    </span>
  )
}
